<div class="banner">
  <h1>white noise</h1>
  <iframe src="https://player.vimeo.com/video/575630263?background=1" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="yt1s.com - TV static noise HD 1080p_1080p.mp4"></iframe><script src="https://player.vimeo.com/api/player.js"></script>
</div>

<div class="section bg">
  <h2>Listen.</h2>
<div class="playlist">
  <div class="art">
    <img src="/whitenoise.jpg" alt="">
  </div>

  <div class="soundcloud">
    <iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/200443551&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/tjwhite3" title="TJ White" target="_blank" style="color: #cccccc; text-decoration: none;">TJ White</a> · <a href="https://soundcloud.com/tjwhite3/animal-behavior" title="Animal Behavior" target="_blank" style="color: #cccccc; text-decoration: none;">Animal Behavior</a></div>
    <iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/200443542&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/tjwhite3" title="TJ White" target="_blank" style="color: #cccccc; text-decoration: none;">TJ White</a> · <a href="https://soundcloud.com/tjwhite3/nite-owl" title="Nite Owl" target="_blank" style="color: #cccccc; text-decoration: none;">Nite Owl</a></div>
    <iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/200443521&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/tjwhite3" title="TJ White" target="_blank" style="color: #cccccc; text-decoration: none;">TJ White</a> · <a href="https://soundcloud.com/tjwhite3/the-hoarder-crow" title="The Hoarder Crow" target="_blank" style="color: #cccccc; text-decoration: none;">The Hoarder Crow</a></div>
    <iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/200443520&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe><div style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"><a href="https://soundcloud.com/tjwhite3" title="TJ White" target="_blank" style="color: #cccccc; text-decoration: none;">TJ White</a> · <a href="https://soundcloud.com/tjwhite3/stuck-pinky" title="Stuck Pinky" target="_blank" style="color: #cccccc; text-decoration: none;">Stuck Pinky</a></div>
  </div>
</div>
</div>

<div class="section bg2">
  <h2>Dates.</h2>
  <div class="text">
    TBD.
  </div>
</div>

<footer>
  <div>
  &copy; whitenoise { new Date().getFullYear() }
  </div>
</footer>

<style>
  .banner {
    overflow: hidden;
    padding-top: 56.25%;
    position: relative;
    width: 100vw; 
  }

  .banner :global( iframe ) {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .banner h1 {
    color: #ccc;
    font-size: 5rem;
    font-weight: 600;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translateY( -50% );
    width: 100%;
    z-index: 100;
  }

  .playlist {
    display: flex;
    flex-direction: column;
    max-width: 100rem;
    grid-gap: 2.5rem;
    margin: 0 auto;
  }

  img {
    max-width: 100%;
  }

  @media screen and ( min-width: 500px ) {
    .playlist {
      flex-direction: row;
    }
  }

  .section {
    padding: 5rem 1rem;
  }

  .section.bg {
    background-color: #f9efe2;
  }

  .art {
    max-width: 50rem;
  }

  .soundcloud {
    width: 100%;
  }

  .section h2 {
    font-size: 5rem;
    font-weight: 600;
    margin: 0 auto;
    max-width: 100rem;
  }

  .section .text {
    font-size: 2rem;
    max-width: 100rem;
    margin: 0 auto;
  }

  .section.bg2 {
    background-color: #777676;
    color: white;
  }

  footer {
    background-color: #333;
    color: white;
  }

  footer div {
    font-size: 1.25rem;
    margin: 0 auto;
    max-width: 100rem;
    padding: 1rem;
    text-align: right;
  }
</style>
